// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"8e4cab52","496":"8d8889c6","647":"ed4f34fb"}[chunkId] + ".chunk.js";
};